import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
  TableBodySkeleton,
} from '../../../common/components';

const BranchesDataTable = ({ data, isLoading, onEdit, onDelete, LoadingComponent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <TableBodySkeleton variant="box" />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((branch, index) => (
              <Box
                key={branch.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Empresa
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {branch.description}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Dirección
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {branch.adress}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Localidad
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {branch.city}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Provincia
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {branch.province}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(branch)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(branch)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron sucursales" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="branches table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="20%" wxs="25%">
              Empresa
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="25%">
              Dirección
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="20%">
              Localidad
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="20%">
              Provincia
            </HeadTableCell>
            <HeadTableCell wmd="20%" wxs="10%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((branch, index) => (
              <TableRow key={branch.uuid || index}>
                <RowTableCell>{branch.description}</RowTableCell>
                <RowTableCell>{branch.adress}</RowTableCell>
                <RowTableCell>{branch.city}</RowTableCell>
                <RowTableCell>{branch.province}</RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(branch)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(branch)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={5} message="No se encontraron sucursales" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default BranchesDataTable;
